import Vue from 'vue';
import Router from 'vue-router';
import DemoLayout from './layouts/demo.vue';
// import VueI18n from 'vue-i18n';

Vue.use(Router);
// Vue.use(VueI18n);

// const i18n = new VueI18n({
//   locale: 'zh-CN', // 语言标识
//   //this.$i18n.locale // 通过切换locale的值来实现语言切换
//   messages: {
//     'zh-CN': require('./components/lang/cn'), // 中文语言包
//     'en-US': require('./components/lang/en'), // 英文语言包
//   },
// });
import main from './views/newWeb/main';
import service from './views/newWeb/service';
import quailty from './views/newWeb/quailty';
import container from './views/newWeb/container';
import vendor from './views/newWeb/vendor';
import product from './views/newWeb/product';
import contact from './views/newWeb/contact';
import guide from './views/newWeb/guide';
import FQA from './views/newWeb/FQA';
import fastStartN from './views/newWeb/fastStart/fastStart.vue';

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/demo',
      component: DemoLayout,
      children: [
        {
          path: 'list',
          name: 'demo-list',
          component: () => import('./views/demo/list.vue'),
        },
      ],
    },
    // 新版web
    {
      path: '/main',
      name: 'main',
      component: main,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    {
      name: 'service',
      path: '/service',
      component: service,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    {
      name: 'quailty',
      path: '/quailty',
      component: quailty,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    {
      name: 'container',
      path: '/container',
      component: container,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    {
      name: 'vendor',
      path: '/vendor',
      component: vendor,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    {
      name: 'product',
      path: '/product',
      component: product,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    {
      name: 'contact',
      path: '/contact',
      component: contact,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    {
      name: 'guide',
      path: '/guide',
      component: guide,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    {
      name: 'FQA',
      path: '/FQA',
      component: FQA,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    {
      name: 'fastStartN',
      path: '/fastStartN',
      component: fastStartN,
      meta: {
        title: '曼德全球', //主要是这个title
      },
    },
    //关于我们
    {
      path: '/about',
      name: 'about',
      enName: 'about',
      component: () => import('./views/about/About.vue'),
    },
    //  首页
    {
      path: '/home',
      name: 'home',
      enName: 'home',
      component: () => import('./views/newWeb/main/index'),
    },
    // 品控服务页面
    {
      path: '/qaqc',
      name: 'qaqc',
      component: () => import('./views/serviceBody/qaQcService'),
    },
    // 供应商评估
    {
      path: '/serveSupplier',
      name: 'serveSupplier',
      component: () => import('./views/serveSupplier/serveSupplier'),
    },
    // FAQ页面
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/FAQ/faq'),
    },
    // 快速上手
    {
      path: '/fastStart',
      name: 'fastStart',
      component: () => import('./views/fastStart/fastStart'),
    },
    // 报告样本
    {
      path: '/reportDemo',
      name: 'reportDemo',
      component: () => import('./views/reportDemo/reportDemo'),
    },
    //  注册页面
    {
      path: '/register',
      name: 'register',
      enName: 'register',
      component: () => import('./views/register/register'),
    },
    // 登录页面
    {
      path: '/login',
      name: 'login',
      enName: 'login',
      component: () => import('./views/login/login'),
    },
    // 忘记密码页面
    {
      path: '/forgetPassword',
      name: 'forgetPassword',
      enName: 'forgetPassword',
      component: () => import('./views/forgetPassword/forgetPassword'),
    },
    //  微信支付页面
    {
      path: '/wechpayment',
      name: 'wechpayment',
      enName: 'wechpayment',
      component: () => import('./components/weChatPayment/index'),
    },
    //  支付宝支付页面
    {
      path: '/AlipayPayment',
      name: 'AlipayPayment',
      enName: 'AlipayPayment',
      component: () => import('./components/AlipayPayment/index'),
    },
    // 线下支付
    {
      path: '/underpayment',
      name: 'underpayment',
      enName: 'underpayment',
      component: () => import('./components/underPayment/index'),
    },
    // PayPal支付成功页面
    {
      path: '/successfulPayment',
      name: '支付成功',
      component: () => import('./views/paymentResult/SuccessfulPayment'),
    },
    // PayPal支付失败页面
    {
      path: '/failPayment',
      name: '支付失败',
      component: () => import('./views/paymentResult/FailPayment'),
    },
    {
      path: '/',
      name: 'list2',
      component: () => import('./views/demo/list2'),
      children: [
        {
          path: '/myhome',
          name: '我的首页',
          alias: '/',
          component: () => import('./views/myHome2/index'), //2019/12/27 修改成新的首页
          meta: { title: '我的首页', menu: '/', enName: 'My Minder' },
        },
      ],
    },
    {
      path: '/',
      name: 'list',
      component: () => import('./views/demo/list'),
      children: [
        /*我的首页*/
        /*{
          path: '/myhome',
          name: '我的首页',
          alias: '/',
          component: () => import('./views/myHome2/index'), //2019/12/27 修改成新的首页
          meta: { title: '我的首页', menu: '/', enName: 'My Minder' },
        },*/
        // ==========快速订单========
        // 验货
        {
          path: '/goods',
          name: '验货',
          component: () => import('./views/downOrder/goods'),
          meta: { title: '验货', menu: 'sub1', enName: 'Product Inspection' },
          children: [
            {
              path: 'start',
              name: '中期验货',
              component: () => import('./views/downOrder/componentsGd/start'),
              meta: {
                title: '中期',
                menu: 'start',
                enName: 'During Production Inspection',
              },
              alias: '/'
            },
            {
              path: 'centre',
              name: '尾期验货',
              component: () => import('./views/downOrder/componentsGd/centre'),
              meta: {
                title: '尾期',
                menu: 'centre',
                enName: 'Final Inspection'
              }
            },
            {
              path: 'end',
              name: '面料验货',
              component: () => import('./views/downOrder/componentsGd/end'),
              meta: {
                title: '面料',
                menu: 'end',
                enName: 'Fabric Inspection',
              }
             
            },
          ],
        },
        {
          path: '/goodsml',
          name: '面料验货',
          component: () => import('./views/downOrder/goodsml'),
          meta: { title: '面料验货', menu: 'sub1', enName: 'Product Inspection' },
          children: [
            {
              path: 'end',
              name: '面料验货',
              component: () => import('./views/downOrder/componentsGd/end'),
              meta: {
                title: '面料',
                menu: 'end',
                enName: 'Fabric Inspection',
              } ,alias: '/'
             
            },
          ],
        },
        // 验厂
        {
          path: 'factory',
          name: '验厂',
          component: () => import('./views/downOrder/factory'),
          meta: { title: '验厂', menu: 'sub1', enName: 'Factory Assessment' },
          children: [
            {
              path: 'checkmill',
              name: '质量验厂',
              component: () =>
                import('./views/downOrder/componentsFy/checkMill'),
              meta: {
                title: '质量验厂',
                menu: 'checkMill',
                enName: 'Factory Assessment',
              },
              alias: '/',
            },
            {
              path: 'supplier',
              name: '供应商评估',
              component: () =>
                import('./views/downOrder/componentsFy/supplier'),
              meta: {
                title: '供应商评估',
                menu: 'supplier',
                enName: 'Vendor Assessment',
              },
            },
          ],
        },
        // 监装
        {
          path: 'supervision',
          name: '监装',
          component: () => import('./views/downOrder/supervision'),
          meta: { title: '监装', menu: 'sub1', enName: 'Loading Supervision' },
        },
        // ==========用户中心=========
        // 基本信息
        {
          path: 'basic',
          name: '基本信息',
          component: () => import('./views/user/basic'),
          meta: {
            title: '基本信息',
            menu: 'sub9',
            enName: 'General Information',
          },
        },
        // 安全等级
        {
          path: 'safeGrade',
          name: '安全等级',
          component: () => import('./views/user/safeGrade'),
          meta: { title: '安全等级', menu: 'sub9', enName: 'Security Level' },
        },
        // 企业资料
        {
          path: 'enterprise',
          name: '企业资料',
          component: () => import('./views/user/enterprise'),
          meta: { title: '企业资料', menu: 'sub9', enName: 'Company Profile' },
        },
        // 我的钱包
        // {
        //   path: 'myWallet',
        //   name: '我的钱包',
        //   component: () => import('./views/user/myWallet'),
        //   meta: { title: '我的钱包', menu: 'sub9', enName: 'My Account' },
        // },
        // 我的套餐
        {
          path: 'mySetMeal',
          name: '我的套餐',
          component: () => import('./views/user/mySetMeal'),
          meta: { title: '我的套餐', menu: 'sub9', enName: 'My Package' },
        },
        // 我的代金券
        {
          path: 'myVouchers',
          name: '我的代金券',
          component: () => import('./views/user/myVouchers'),
          meta: { title: '我的代金券', menu: 'sub9', enName: 'My Dai Jinjun' },
        },
        // 支付方式
        {
          path: 'pay',
          name: '支付方式',
          component: () => import('./views/pay/modeOfPayment'),
          meta: { title: '支付方式', menu: 'sub9', enName: 'Payment method' },
        },
        //===========我的订单========
        {
          path: 'allorder',
          name: '全部订单',
          component: () => import('./views/myOrder/allOrder'),
          meta: { title: '全部订单', menu: 'sub2', enName: 'All Orders' },
        },
        {
          path: 'notFinished',
          name: '未完成',
          component: () => import('./views/myOrder/notFinished'),
          meta: { title: '未完成', menu: 'sub2', enName: 'Uncompleted' },
        },
        {
          path: 'complete',
          name: '已完成',
          component: () => import('./views/myOrder/complete'),
          meta: { title: '已完成', menu: 'sub2', enName: 'Completed' },
        },
        {
          path: 'cancel',
          name: '已取消',
          component: () => import('./views/myOrder/cancel'),
          meta: { title: '已取消', menu: 'sub2', enName: 'Canceled' },
        },
        {
          path: 'draft',
          name: 'Drafts',
          component: () => import('./views/myOrder/draft'),
          meta: { title: '草稿箱', menu: 'sub2', enName: 'Product Inspection' },
        },
        //===========我的评价========
        {
          path: 'noEvaluate',
          name: '待评价',
          component: () => import('./views/myEvaluate/noEvaluate'),
          meta: { title: '待评价', menu: 'sub3', enName: 'Wait for review' },
        },
        {
          path: 'yesEvaluate',
          name: '已评价',
          component: () => import('./views/myEvaluate/yesEvaluate'),
          meta: { title: '已评价', menu: 'sub3', enName: 'Reviewed' },
        },
        //===========我的投诉========
        {
          path: 'complaint',
          name: '投诉列表',
          component: () => import('./views/myComplain/complaint'),
          meta: {
            title: '投诉列表',
            menu: 'sub4',
            enName: 'Product Inspection',
          },
        },
        //===========我的评价========
        {
          path: 'evaluate',
          name: '投诉列表',
          component: () =>
            import('./views/myEvaluate/components/evaluateComponents'),
          meta: {
            title: '投诉列表',
            menu: 'sub4',
            enName: 'Product Inspection',
          },
        },
        //==========我的报告=========
        {
          path: 'reportManage',
          name: '报告管理',
          component: () => import('./views/reportManage/index'),
          meta: {
            title: '报告管理',
            menu: 'sub5',
            enName: 'Report management',
          },
        },
        //==========报告详情=========
        {
          path: '/reportManage/reportBasic',
          name: '查看报告',
          component: () => import('./views/reportManage/reportBasic'),
          meta: { title: '查看报告', menu: 'sub5', enName: 'View reports' },
        },
        {
          path: '/reportManage/supervisionReportBasic',
          name: '查看报告(监装)',
          component: () =>
            import('./views/reportManage/supervisionReportBasic'),
          meta: {
            title: '查看报告(监装)',
            menu: 'sub5',
            enName: 'View reports',
          },
        },
        {
          path: '/reportManage/fabricReportBasic',
          name: '查看报告(面料)',
          component: () => import('./views/reportManage/fabricReportBasic'),
          meta: {
            title: '查看报告(面料)',
            menu: 'sub5',
            enName: 'View reports',
          },
        },
        {
          path: '/reportManage/factoryReportBasic',
          name: '查看报告(验厂)',
          component: () => import('./views/reportManage/factoryReportBasic'),
          meta: {
            title: '查看报告(验厂)',
            menu: 'sub5',
            enName: 'View reports',
          },
        },
      ],
    },
  ],
});
router.beforeEach((to, from, next) => {
  // let token = Vue.cookie.get('token');
  let token = sessionStorage.getItem('token');
  if (
    to.path === '/home' ||
    to.path === '/register' ||
    to.path === '/about' ||
    to.path === '/login' ||
    to.path === '/qaqc' ||
    to.path === '/faq' ||
    to.path === '/fastStart' ||
    to.path === '/reportDemo' ||
    to.path === '/serveSupplier' ||
    to.path === '/forgetPassword' ||
    to.path === '/successfulPayment' ||
    to.path === '/failPayment' ||
    to.path === '/quailty' ||
    to.path === '/container' ||
    to.path === '/vendor' ||
    to.path === '/product' ||
    to.path === '/guide' ||
    to.path === '/FQA' ||
    to.path === '/contact' ||
    to.path === '/fastStartN' ||
    to.path === '/main'
  ) {
    next();
  } else if (!token || !/\S/.test(token)) {
    next('/home');
  } else {
    next();
  }
});
export default router;
